import React from 'react';
import { FaArrowAltCircleRight, FaWindowClose } from 'react-icons/fa';

const Success = ({setNavLinks, isFromContactJs}) => {
  return (
    <div className='container-fluid'>

        <div className='close-window-icon' >
            <FaWindowClose color='#1b2328' onClick={()=> isFromContactJs ? setNavLinks({contactLink: true}): setNavLinks({homeLink: true}) }/>
        </div>
        <div className='d-flex flex-column gap-2 justify-content-center align-items-center mt-5'>

                <h3>{isFromContactJs?'Successful! Thanks for Contacting us. We will get back to you shortly' : 'Your Subscription for our newsletter was successful, Thanks.'}</h3>

                <button className='btn btn-success' onClick={()=>setNavLinks({serviceLink: true})}>View Our Service <FaArrowAltCircleRight/></button>
        </div>
          


    </div>
  )
}

export default Success;